import React from 'react';
import './App.css';
import {BrowserRouter, Routes, Route } from "react-router-dom";
import {IS_TEST} from "./utils/config";
import {Bounce, ToastContainer} from "react-toastify";
import HomePage from "./pages/HomePage";
import DeployDetailPage from "./pages/DeployDetailPage";
import PackageDetailPage from "./pages/PackageDetailPage";

function App() {
    return (
        <div>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage/>} />
                    <Route path="/detail/deploy" element={<DeployDetailPage/>} />
                    <Route path="/detail/package" element={<PackageDetailPage/>} />
                </Routes>
            </BrowserRouter>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                closeButton={false}
                hideProgressBar={true}
                newestOnTop={false}
                rtl={false}
                pauseOnFocusLoss={IS_TEST}
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
        </div>
    );
}

export default App;
